import type { AtsCommTemplateVariables } from './atsCommTemplateVariables';

/**
 * BE quirk: the `availability_link` merge variable is keyed
 * `interview.availability_link`, but the variables endpoint returns it under a
 * dedicated `candidate_availability` bucket — see core
 * `ats_comm_templates_controller#set_view_variables`:
 *   `add_to_attributes(@variables["candidate_availability"], "interview",
 *      AtsInterviewDrop::CANDIDATE_AVAILABILITY_LIQUID_ATTRIBUTES)`.
 * The kula variable picker derives a tab label from the bucket key
 * (`candidate_availability` → first segment → "Candidate"), so it renders a
 * confusing second "Candidate" tab whose only entry is `interview.*`.
 *
 * Fold that bucket into `interview` so the availability link shows under the
 * "Interview" tab, where its token belongs. FE-side relocation (no BE change);
 * the flattened key set is unchanged, so variable validation is unaffected.
 */
export const AVAILABILITY_VARIABLE_CATEGORY = 'candidate_availability';
export const INTERVIEW_VARIABLE_CATEGORY = 'interview';

export function groupAvailabilityUnderInterview(
  variables: AtsCommTemplateVariables
): AtsCommTemplateVariables {
  const availability = variables[AVAILABILITY_VARIABLE_CATEGORY];
  if (!availability?.length) {
    return variables;
  }

  const { [AVAILABILITY_VARIABLE_CATEGORY]: _availability, ...rest } =
    variables;
  const existingInterview = rest[INTERVIEW_VARIABLE_CATEGORY] ?? [];

  return {
    ...rest,
    [INTERVIEW_VARIABLE_CATEGORY]: Array.from(
      new Set([...existingInterview, ...availability])
    ),
  };
}
